module.exports = __webpack_public_path__ + "static/media/ste_wor_haz_lev.f5908f9b.png";